import Vue from 'vue'
import Vuex from 'vuex'
import info                          from "../../api/user/info";
import sendSms                       from "../../api/sms/sendSms";
import phoneFormat                   from "../../helpers/phoneFormat";
import checkUserByPhone              from "../../api/user/checkUserByPhone";
import checkUserBirthday             from "../../api/user/checkUserBirthday";
import register                      from "../../api/user/register";
import createUser                    from "../../api/user/createUser";
import forgotPassword                from "../../api/user/forgotPassword";
import resetPassword                 from "../../api/user/resetPassword";
import loginRequest                  from "../../api/user/login";
import checkCredentials              from "../../api/user/checkCredentials";

Vue.use(Vuex)


const state = {
    phone: null,
    user: {
        id: null,
        phone: null,
        email: null,
        patients: []
    },
    patient:null,
    api_token: null,
}
const mutations = {
    SET_API_TOKEN(state, payload) {
        state.api_token = payload;
    },
    SET_PHONE(state, payload) {
        state.phone = payload
    },
    SET_USER(state, payload) {
        state.user = payload
    },
    SET_PATIENT(state, payload) {
        state.patient = payload
    },
}
const actions = {
    getUserInfo({state,commit}, token) {
        return info(token).then((response) => {
            commit('SET_USER', response)
            if(response.patients){
                let patient = response.patients.find((item) => item.id === state.patient.id)
                commit('SET_PATIENT',patient)
            }
        })
    },
    sendSms({commit, dispatch}, payload) {
        let type = payload.type === null ? 'registration' : payload.type
        let formattedPhone = phoneFormat(payload.phone)
        let tokenReCaptcha = payload.tokenReCaptcha

        commit('SET_PHONE', formattedPhone)

        return sendSms(formattedPhone, type, tokenReCaptcha)
    },
    checkUserBirthDay({commit, dispatch}, payload) {
        return checkUserBirthday(payload)
    },
    checkUser({commit, dispatch}, payload) {
        return checkUserByPhone(payload)
    },
    createUserFromPatient({commit, dispatch}, payload) {
        return createUser(payload)
    },
    registerUser({commit, dispatch}, payload) {
        return register(payload);
    },
    forgotPassword({commit, dispatch}, payload) {
        return forgotPassword(payload);
    },
    resetPassword({commit, dispatch}, payload) {
        return resetPassword(payload);
    },
    setPatient({commit},payload){
        commit('SET_PATIENT', payload)
    },
    login({commit, dispatch}, payload) {
        let data = {
            login: phoneFormat(payload.login),
            password: payload.password,
            sms_code: payload.sms_code,
            sms_token: payload.sms_token,
        }
        return loginRequest(data).then(async (responseLogin) => {
            commit('SET_API_TOKEN', responseLogin.api_token)
            const responseUser = await info(responseLogin.api_token);

            responseUser.id = responseLogin.id
            commit('SET_USER', responseUser)
            commit('SET_PATIENT', responseUser.patients[0])
            dispatch('clearErrors')

        }).catch(({err, response}) => {
            dispatch('setError', response.data)
        })
    },
    logout({commit}, reload = true) {
        commit('SET_USER', {
            id: null,
            login: null,
            name: null,
            birthday: null,
            phone: null,
            address: null,
            email: null,
            confirm_email: null,
            confirm_phone: null,
            available_record_today: null,
        });

        commit('SET_API_TOKEN', null);
        commit('SET_PATIENT', null);
        if (reload) {
            window.location.reload(true);
        }
    },

    checkCredentials({commit, dispatch}, payload) {
        const data = {
            login: phoneFormat(payload.login),
            password: payload.password
        }

        return checkCredentials(data).then(async (response) => {
            dispatch('clearErrors');
        }).catch(({err, response}) => {
            dispatch('setError', response.data);
        })
    }
}

export default {
    state,
    mutations,
    actions
}
